'use strict'

import moment from 'moment'

import css from './ums-report-card.styles.scss'
import template from './ums-report-card.template.pug'

export class ReportCardController {
  constructor($mdDialog, $mdToast, $filter, $scope) {
    'ngInject'
    Object.assign(this, { $mdDialog, $mdToast, $filter, $scope })
  }

  remove(ev) {
    var confirm = this.$mdDialog
      .confirm()
      .title('Sind Sie sicher?')
      .textContent('Das Löschen eines Reports kann nicht rückgängig gemacht werden.')
      .ok('Löschen')
      .cancel('Abbrechen')
      .targetEvent(ev)

    this.$mdDialog
      .show(confirm)
      .then(() => this.customer.deleteReport(this.report.no))
      .then(() => this.onDelete())
  }

  download() {
    const date = moment(this.report.createdAt).format('YYYY-MM-DD')
    const title = this.report.title.replace(/\s/g, '_')
    return this.customer.getReport(this.report.no, `${date}_${title}`)
  }
}

export const umsReportCard = {
  template: template({ css }),
  bindings: {
    report: '<',
    customer: '<',
    onDelete: '&',
  },
  controller: ReportCardController,
}



// WEBPACK FOOTER //
// ./app/reports/components/report-card/ums-report-card.component.js